import axios from "axios";
import { APP_SETTINGS } from "../../config";

export function getSchedulerData() {
  return axios.post(APP_SETTINGS.API_PATH.SCHEDULER.getSchedulerList);
}

export function addSchedulerEvent(schedulerData) {
  return axios.post(
    APP_SETTINGS.API_PATH.SCHEDULER.addSchedulerEvent,
    schedulerData
  );
}

export function deleteSchedulerEvent(schedulerData) {
  return axios.post(
    APP_SETTINGS.API_PATH.SCHEDULER.deleteSchedulerEvent,
    schedulerData
  );
}

export function getProjectLookup(organizationId, token) {
  return axios.get(
    `${APP_SETTINGS.API_PATH.SCHEDULER.getProjectLookup}/${organizationId}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
}

export function getUserLookup(organizationId, token) {
  return axios.get(
    `${APP_SETTINGS.API_PATH.SCHEDULER.getUserLookup}/${organizationId}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
}

export function getDepartmentLookup() {
  return axios.get(APP_SETTINGS.API_PATH.SCHEDULER.getDepartmentLookup);
}

export function getTeamLookup() {
  return axios.get(APP_SETTINGS.API_PATH.SCHEDULER.getTeamLookup);
}
export function getSchedulerUsers(filters) {
  return axios.post(APP_SETTINGS.API_PATH.SCHEDULER.getUsers, filters);
}
export function getSchedulerProjects(filters) {
  return axios.post(APP_SETTINGS.API_PATH.SCHEDULER.getProjects, filters);
}
export function getSchedulerTasks(filters) {
  return axios.post(APP_SETTINGS.API_PATH.SCHEDULER.getTasks, filters);
}
export function getUserProjectsTask(filters, token) {
  return axios.post(
    APP_SETTINGS.API_PATH.SCHEDULER.getUserProjectsTask,
    filters,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
}
export function updateTaskDueDate(payload, token) {
  return axios.post(
    APP_SETTINGS.API_PATH.SCHEDULER.updateTaskDueDate,
    payload,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
}

export function getProjectUsersTask(filters, token) {
  return axios.post(
    APP_SETTINGS.API_PATH.SCHEDULER.getProjectUsersTask,
    filters,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
}
export function getTaskDetailsApi(taskId) {
  return axios.get(
    `${APP_SETTINGS.API_PATH.SCHEDULER.getTaskDetails}/${taskId}`
  );
}
